import { IResponse, consumer } from "@bemap/utils";

const ENDPOINT = `/campaign-links/:code/leads`;
const ENDPOINT_WITH_CODE = (code: string) => ENDPOINT.replace(':code', code);

export interface CreateLeadPayload {
  name: string;
  email: string;
  phone?: string;
  code: string;
}

export const createLead = async (payload: CreateLeadPayload): Promise<IResponse> => {
  return consumer('POST', ENDPOINT_WITH_CODE(payload.code), payload);
}

export default {
  createLead,
};


